<template>
    <div class="flex items-center justify-center">
        <span class="relative inline-flex text-white">
            <button
                class="group cursor-pointer"
                @click.stop="toggleAnnouncements"
            >
                <svg
                    class="relative"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width="32"
                        height="32"
                        rx="16"
                        class="duration-50 transition-all ease-out"
                        :class="
                            announcementsOpened
                                ? 'fill-[#FF421E]'
                                : 'fill-[#374151] group-hover:fill-[#4B5563]'
                        "
                    />
                    <g transform="translate(6 6)">
                        <path
                            d="M6.95984 16.8682C7.66075 17.7592 8.76185 18.3333 10 18.3333C11.2382 18.3333 12.3393 17.7592 13.0402 16.8682C11.022 17.1417 8.97801 17.1417 6.95984 16.8682Z"
                            class="transition-all duration-100 ease-out"
                            :fill="!announcementsOpened ? '#FF421E' : '#374151'"
                        />
                        <path
                            d="M15.6243 7.50002V8.08677C15.6243 8.79094 15.8252 9.47935 16.2018 10.0652L17.1247 11.501C17.9677 12.8124 17.3242 14.5949 15.858 15.0097C12.0227 16.0945 7.97728 16.0945 4.14197 15.0097C2.67588 14.5949 2.03235 12.8124 2.8753 11.501L3.79817 10.0652C4.17477 9.47935 4.37573 8.79094 4.37573 8.08677V7.50002C4.37573 4.27836 6.8938 1.66669 10 1.66669C13.1062 1.66669 15.6243 4.27836 15.6243 7.50002Z"
                            class="transition-all duration-100 ease-out"
                            :fill="!announcementsOpened ? '#FF421E' : '#374151'"
                        />
                    </g>
                </svg>
            </button>

            <span
                class="absolute flex items-center justify-center"
                :class="[
                    hasUnreadAnnouncements
                        ? 'right-0 top-0 h-2.5 w-2.5'
                        : 'right-[2px] top-[2px] h-1.5 w-1.5',
                ]"
            >
                <span
                    class="absolute inline-flex h-full w-full rounded-full bg-[#FF421E] opacity-100"
                    :class="{ 'animate-ping': hasUnreadAnnouncements }"
                ></span>
                <span
                    class="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#FF421E]"
                ></span>
            </span>
        </span>
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    announcementsOpened: boolean;
    hasUnreadAnnouncements: boolean;
}>();

const emit = defineEmits(["toggleAnnouncements"]);

const toggleAnnouncements = () => {
    emit("toggleAnnouncements");
};
</script>
